import { css } from '@emotion/react'

const Styles = ({ colors }) => {
  const { scales: { grayShades } } = colors

  return ({
    mainStyle: css`
      max-width: 68rem;
      margin: 0 auto;
      padding: 9rem 1rem 4rem;
      display: flex;
      align-items: left;
      justify-content: space-between;
      flex-direction: column;
      @media (max-width: 768px) { 
        padding: 3.75rem 1rem 0 1rem;
        align-items: center;
        flex-direction: column;
      }
    `,
    sectionContainer: css`
      position: relative;
      display: flex;
      justify-content: center; 
      align-items: center; 
      flex-direction: column;
      clip-path: ellipse(86% 100% at 48% 100%);
      position: relative;
      top: -9.813rem;
      background: ${grayShades[0]};
      @media (max-width: 768px) {
        clip-path: ellipse(275% 97.4% at 50% 100%);
        top: -6.625rem;
        padding: 4.188rem 0 0 0;
      }
    `,
    wrapperStyle: css` 
      text-align: center;
      @media (max-width: 768px) {
        flex-direction: column;
      }
    `,
    containerCards: css`
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      text-align: center;
      margin-bottom: 1.5rem;
      height: 17.25rem !important;
      @media (max-width: 768px) {
        flex-direction: column;
        padding-top: 2.5rem;
        height: 100% !important;
        margin-bottom: 0 !Important;
      }
      `,
    cards: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      height: 11.813rem !important;
      img {
        width: 12.5rem;
        height: 12.5rem;
        text-align: center;
      }
      h6 {
        width: 10.938rem;
        text-align: center;
      }
      @media (max-width: 768px) {
        height: auto !important;
        margin-bottom: 1.5rem;
        img {
          width: 11.813rem;
          height: 11.813rem;
          text-align: center;
        }
      }
      `,
    subtitle: css`
      @media (max-width: 768px) {
        padding: 1.5rem 0 0 0;
      }
    `,
    title: css`
      margin-bottom: 1.5rem !important;
    `
  })
}

export { Styles }
